@if (isEpcotEnabled) {
    <div class="mybets-betslip-info_header">
        @if (bet().betBuilderInfo) {
            <ms-my-bets-multi-bet-betbuilder-title [bet]="bet()"></ms-my-bets-multi-bet-betbuilder-title>
        } @else {
            @if (myBetsUtilService.isBetCardRedesigned()) {
                <ng-container [ngTemplateOutlet]="myBetsBetSlipHeadSectionRedesigned" />
            } @else {
                <ng-container [ngTemplateOutlet]="myBetsBetSlipHeadSection"></ng-container>
            }
        }
    </div>
    @if (bet().betBuilderInfo) {
        <ms-my-bets-betbuilder-expanded-info
            class="mybets-betslip-multi-bet_betbuilder-expanded"
            [bet]="bet()"
            [event]="event()"
            [myBetsListContext]="myBetsListContext()"
            [cashedOut]="cashedOut()"></ms-my-bets-betbuilder-expanded-info>
    }
    <div class="mybets-betslip-info_details">
        <ng-container [ngTemplateOutlet]="myBetsBetSlipInfoSection" />
    </div>
} @else {
    @if (bet().betBuilderInfo) {
        <ms-my-bets-multi-bet-betbuilder-title [bet]="bet()"></ms-my-bets-multi-bet-betbuilder-title>
        <ms-my-bets-betbuilder-expanded-info
            class="mybets-betslip-multi-bet_betbuilder-expanded"
            [bet]="bet()"
            [event]="event()"
            [myBetsListContext]="myBetsListContext()"
            [cashedOut]="cashedOut()"></ms-my-bets-betbuilder-expanded-info>
    } @else {
        <ng-container [ngTemplateOutlet]="myBetsBetSlipHeadSectionNonEpcot" />
    }
    <ng-container [ngTemplateOutlet]="myBetsBetSlipInfoSection" />
}

<ng-template #myBetsBetSlipHeadSection>
    <ng-container [ngTemplateOutlet]="TopRightSection" />
    <ng-container [ngTemplateOutlet]="SingleBetPrintPreview" />
    <ng-container [ngTemplateOutlet]="pickInformation" />
</ng-template>

<ng-template #myBetsBetSlipHeadSectionRedesigned>
    <ng-container [ngTemplateOutlet]="SingleBetPrintPreview" />
    <ng-content select="[mybets-event-info-betslip-headsection]" />
</ng-template>

<ng-template #myBetsBetSlipHeadSectionNonEpcot>
    <ng-container [ngTemplateOutlet]="TopRightSection" />
    <div [class.mybets-betslip-single-bet-header]="showBetslipId()">
        @if (showBetslipId()) {
            <span class="mybets-betslip-single-bet-title bold highlight">{{ sitecoreMyBets.myBets.SingleBet }}</span>
            <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip()?.betslipId }}</span>
        }
    </div>
    @if (showBetslipId()) {
        <div class="mybets-card-divider mybets-single-bet"></div>
    }
    <ng-container [ngTemplateOutlet]="pickInformation" />
</ng-template>

<ng-template #myBetsBetSlipInfoSection>
    <ms-my-bets-betslip-scoreboard [bet]="bet()" [myBetsListContext]="myBetsListContext()" [cashedOut]="cashedOut()">
        <ms-my-bets-scoreboard-wrapper default [event]="event()" />
    </ms-my-bets-betslip-scoreboard>
</ng-template>

<ng-template #pickInformation>
    <div
        class="mybets-betslip-info_pick-data clearfix"
        [ngClass]="{ 'mybets-betslip-info_pick-data--with-paddings': shouldApplyPaddings(), 'pb-0': mybetsConfig.showSportAndCompetitionName }">
        <ms-my-bets-betslip-option-name [bet]="bet()"></ms-my-bets-betslip-option-name>
        <ms-my-bets-betslip-market-name [bet]="bet()"></ms-my-bets-betslip-market-name>
        @if (bet().isBanker) {
            <div class="banker-icon">{{ siteCore.betslip.messages.BankerAbbr }}</div>
        }
    </div>
    @if (mybetsConfig.showSportAndCompetitionName) {
        <div class="mybets-betslip-info clearfix">
            <ms-my-bets-betslip-sport-competition-name [bet]="bet()"></ms-my-bets-betslip-sport-competition-name>
        </div>
    }
</ng-template>

<ng-template #SingleBetPrintPreview>
    <div [class.mybets-betslip-single-bet-header]="showBetslipId()">
        @if (showBetslipId()) {
            <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip()?.betslipId }}</span>
        }
    </div>
</ng-template>

<ng-template #TopRightSection>
    <div class="mybets-betslip-info_right-section clearfix"><ng-content select="[topright-section]" /></div>
</ng-template>
